import { useState } from 'react'
import { useForm } from 'react-hook-form'

import * as relationship from 'lmcv/services/relationship'

import WeeksCount from './steps/WeeksCount'
import ProjectName from './steps/ProjectName'
import InviteCustomer from './steps/InviteCustomer'

const DEFAULT_CUSTOMER_DATA = {
  name: '',
  projectName: '',
  projectWeeks: '0',
  email: ''
}

const DEFAULT_INVITE_DATA = 'https://leroymerlin.com.br/fidelidade'

const WizardForm = ({ prev, next, step, closeDrawer }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [hasError, setHasError] = useState(false)

  const [customerData, setCustomerData] = useState(DEFAULT_CUSTOMER_DATA)
  const [inviteData, setInviteData] = useState(DEFAULT_INVITE_DATA)

  const { errors, handleSubmit, reset, register } = useForm({ mode: 'onChange' })
  const { name, projectName, projectWeeks } = customerData

  const roundValue = (value) => {
    if (value <= 0 || value === '') {
      return '0'
    }

    return `${Math.round(parseFloat(value))}`
  }

  const onCustomerChange = ({ target: { name, value } }) => {
    if (name === 'projectWeeks') {
      return setCustomerData({
        ...customerData,
        [name]: roundValue(value)
      })
    }

    setCustomerData({
      ...customerData,
      [name]: value
    })
  }

  const onCustomerDataSubmit = async () => {
    setIsLoading(true)

    const payload = {
      customerName: name,
      weekCount: +projectWeeks,
      projectName: projectName
    }

    const handleSuccess = ({ inviteUrl }) => {
      setInviteData(inviteUrl)
      next()
    }

    const handleError = (err) => {
      console.error(err)
      setHasError(true)
    }

    await relationship
      .createProject(payload)
      .then(handleSuccess)
      .catch(handleError)
      .finally(() => setIsLoading(false))
  }

  const stepsCommonProps = {
    step,
    errors,
    register,
    customerData
  }

  return (
    <form
      onChange={onCustomerChange}
      onSubmit={handleSubmit(onCustomerDataSubmit)}
    >
      <ProjectName
        {...stepsCommonProps}
        nextStep={() => next(reset, customerData)}
      />
      <WeeksCount
        {...stepsCommonProps}
        hasError={hasError}
        isLoading={isLoading}
        prevStep={() => prev(reset, customerData)}
      />
      <InviteCustomer
        {...stepsCommonProps}
        inviteUrl={inviteData}
        closeDrawer={closeDrawer}
      />
    </form>
  )
}

export default WizardForm
